import { render, staticRenderFns } from "./pfdo-new-year.vue?vue&type=template&id=56afe345&scoped=true&"
var script = {}
import style0 from "./pfdo-new-year.vue?vue&type=style&index=0&id=56afe345&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56afe345",
  null
  
)

export default component.exports